module.exports = __webpack_public_path__ + "img/dots-vertical-circle-outline.a322dd7e.svg";